import createApiClient from "./api";

const client = createApiClient();
const formDataClient = createApiClient(true);

export const api = {

  getModules: (params) => {
    const { search, perPage, currentPage, sortBy, order } = params || {};
    return client
      .get(`admin/modules?perPage=${perPage || 25}${
                search ? `&search=${search}` : ""
              }&page=${currentPage || 1}${sortBy ? `&sortBy=${sortBy}` : ''}${order ? `&order=${order}` : ''}`)
      .then(({ data }) => data);
  },

  getCoursesSummary: () => client.get(`/admin/courses/get/summary`)
                       .then(({ data }) => data),

  createModule: (payload) => client.post(`admin/modules`, payload).then(({ data }) => data ),

  deleteModule: (moduleId) => client.delete(`admin/modules/${moduleId}`).then(({ data }) => data),

  getCourses: (params) => {
    const { search, perPage, currentPage, status, category, sortBy, order } = params || {};
    return client.get(`admin/courses?perPage=${perPage || 25}${ search ? `&search=${search}` : ''}&page=${
        currentPage || 1
    }${ status ? `&status=${status}` : ''}${ category ? `&categoryId=${category}` : ''}${sortBy ? `&sortBy=${sortBy}` : ''}${order ? `&order=${order}` : ''}`)
    .then(({ data }) => data);
  }, 

  getCourseDetails: ({id}) => client.get(`admin/courses/${id}`).then(({ data }) => data),

  createCourse: (payload) => client.post(`admin/courses`, payload).then(({ data }) => data),

  updateCourse: (payload, id) => client.patch(`admin/courses/${id}`, payload).then(({ data }) => data),

  getCategories: (params) => {
    const { search, perPage, currentPage, sortBy, order } = params || {};
    return client.get(`admin/categories?perPage=${perPage || 1000}${ search ? `&search=${search}` : ''}&page=${
      currentPage || 1
    }${sortBy ? `&sortBy=${sortBy}` : ''}${order ? `&order=${order}` : ''}`).then(({ data }) => data);
  },

  createCategory: (payload) => client.post(`admin/categories`, payload).then(({ data }) => data),

  updateCategory: (payload, id) => client.patch(`admin/categories/${id}`, payload).then(({ data }) => data),

  deleteCategory: (id) => client.delete(`admin/categories/${id}`).then(({ data }) => data),

  createResource: (payload) => formDataClient.post('upload-file', payload),

  previewModule: ({ id, language, search }) => client.post(`admin/modules/${id}/preview${language ? `?language=${language}` : ''}${search ? `${language ? '&' : '?'}search=${search}` : ''}`)
  .then(({ data }) => data),
   
  getModuleResult: ({id, previewId, search}) => client.get(`/admin/modules/${id}/preview/${previewId}${search ? `?search=${search}` : ''}`)
  .then(({ data }) => data),
  
  uploadModule: (payload) => formDataClient.post('upload-module-zip', payload),

  assignModuleToCourse: (payload) => 
    client.post(`admin/courses/${payload?.id}/assign-modules`, payload?.data)
    .then(({ data }) => data),

  unassignModuleFromCourse: (payload) =>
    client.post(`admin/courses/${payload?.id}/unassign-modules`, payload?.data)
    .then(({ data }) => data),

  addResourceToModule: ({payload, courseId, moduleId}) => 
    client.post(`admin/resources`, payload)
    .then(({ data }) => data),

  updateModule: (payload,id) => client.patch(`admin/modules/${id}`, payload).then(({ data }) => data),

  getCreditCodes: ({perPage})  => client.get(`/admin/credit-codes?perPage=${perPage || 1000}`)
  .then(({ data }) => data),

  getIndividualCourse: (id) => client.get(`/admin/courses/${id}`)
    .then(({ data }) => data),

  getIndividualModule: (id) => client.get(`/admin/modules/${id}`)
    .then(({ data }) => data),
    
  getCourseRatings: ({ search, perPage, currentPage, courseId }) => client
    .get(`admin/courses/${courseId}/ratings?perPage=${perPage}${
              search ? `&search=${search}` : ""
            }&page=${currentPage}`)
    .then(({ data }) => data),
};
